@use '../../styling/form-controls.scss' as *;
@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;
@use 'sass:color' as sassColor;

$hover-shadow-primary: sassColor.adjust($color-primary-purple, $alpha: -0.8);
$hover-shadow-error: sassColor.adjust($color-primary-red, $alpha: -0.8);

.TextArea {
  .Layout {
    @extend %form-control-border;
    @extend %form-control-background;

    display: flex;
    gap: 4px;
    align-items: flex-start;
    padding: 7px;
    padding-left: 16px;
    box-sizing: border-box;
    overflow: hidden;

    &:hover {
      box-shadow: 0 0 0 3px $hover-shadow-primary;
    }

    &:focus-within {
      border-color: $color-primary-purple;
      box-shadow: 0 0 0 3px $hover-shadow-primary;
    }

    &.Readonly {
      background-color: $theme-color-input-readonly;
      color: $theme-color-readonly-field-text;
      border: 1px solid $theme-color-input-readonly-border;

      textarea::placeholder {
        color: $theme-placeholder-text;
      }

      &:hover,
      &:focus,
      &:focus-within {
        box-shadow: none;
      }
    }

    &.Disabled {
      @extend .Readonly;
    }

    &.Invalid {
      border-color: $color-primary-red;

      &:hover,
      &:focus-within {
        box-shadow: 0 0 0 3px $hover-shadow-error;
      }
    }
  }

  textarea {
    @extend %form-control-font;

    flex-grow: 1;
    border: none;
    outline: none;
    box-sizing: border-box;
    appearance: none;
    width: 100%;
    background-color: transparent;
    resize: vertical;
    line-height: 18px;

    &[disabled] {
      color: $theme-color-readonly-field-text !important;
      cursor: not-allowed;
      pointer-events: none;
      box-shadow: none;

      ::placeholder {
        color: $theme-color-text;
      }
    }
  }

  .TrailingIcon {
    display: inline-flex;
    align-items: center;
    color: $color-grey-B;
  }

  .LayoutSecondary {
    display: flex;
    column-gap: 4px;
    padding: 8px 2px;
  }

  .Spacer {
    flex-grow: 1;
  }

  .ClearBtn {
    @extend %form-control-font;
  }

  .ErrorMessage {
    @extend %form-control-invalid-font;

    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
    column-gap: 6px;
    font-size: $font-size-normal;

    .ErrorIcon {
      align-self: baseline;
      margin-top: 3px;
    }
  }
}
